import StyledButton from '../atoms/StyledButton';

const ErrorFallback = ({ error }) => {
    return (
        <div
            style={{
                backgroundColor: '#1a1d30',
                width: '100vw',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px',
                    color: '#333',
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    margin: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}
            >
                <p>We apologize for the inconvenience. An error occurred while loading the page.</p>
                <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', maxWidth: '100%' }}>
                    {error.message}
                </pre>
                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'center',
                        backgroundColor: '#1a1d30',
                    }}
                >
                    <StyledButton onClick={() => window.location.reload()}>
                        Reload page
                    </StyledButton>
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
